/**
 * This function will accept path, params and include params into path
 *
 * @param {string} path
 * @param {object} [params] Object with path's params
 * @returns {string} Url with params
 * */

const pathToUrl = (path, params) => {
  if (params) {
    let href = path;

    Object.keys(params).forEach(key => {
      const regexp = new RegExp(`:${key}[\?]?`, 'ig');

      href = href.replace(regexp, params[key]);
    });

    return href;
  }

  return path;
};

export default pathToUrl;
